import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { fileColumns } from './grid-columns';
import { SiTrackGrid } from '../../../components/si-track-grid/si-track-grid';
import { workOrdersApiKeyStore } from '../../../api/workorders-api-key-store';
import { useFileDownload } from '../../../components/file-download';
import { UserPermissionName } from '../../../models/user-permission-name';

interface FileDownloadDialog {
  workOrderID: any;
  onClosed: () => void;
}
export const FileDownloadDialog = ({ workOrderID, onClosed }: FileDownloadDialog) => {
  const { downloadFile, isLoading } = useFileDownload();

  const handleDownloadFile = async (data: any) => {
    downloadFile({ additionalData: data });
  };
  return (
    <Dialog
      open={true}
      fullWidth={true}
      maxWidth={'xl'}
      // onClose={onClosed}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={{ p: 2, pt: 1, pb: 1, m: 0 }}>
        VIEW / DOWNLOAD PDF
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClosed}
        sx={{
          position: 'absolute',
          right: 10,
          top: 3,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Tooltip title={<Typography variant="body1">Close</Typography>}>
          <CloseIcon />
        </Tooltip>
      </IconButton>
      <DialogContent dividers className="popupDilog">
        <SiTrackGrid
          fileTitle='workorder_file'
          dataItemKey="fileID"
          columns={fileColumns}
          queryConfig={workOrdersApiKeyStore.getWOFileList(workOrderID)}
          onDownload={(data: any) => {
            handleDownloadFile(data);
          }}
          actionPermissions={{
            export: UserPermissionName.DOWNLOAD_GRID,
            download: UserPermissionName.DOWNLOAD_FILE,
          }}
          isBusy={isLoading}
        />
      </DialogContent>
    </Dialog>
  );
};
